@use '@/styles/tokens' as *;

.person {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  max-width: 100%;
  vertical-align: bottom;
}

.personText {
  display: inline-flex;
  flex-direction: column;
  min-width: 0; // lets the name's `.text` ellipsis engage in a bounded column
  line-height: 1.2;
}

.personSecondary {
  font-size: 9px;
  color: var(--text-tertiary);
}

.id {
  display: inline-flex;
  align-items: center;
  gap: $space-1;
  max-width: 100%;
  vertical-align: bottom;
}

.idCopy {
  flex-shrink: 0;
}

.text {
  @include truncate;
  display: inline-block;
  max-width: 100%;
  min-width: 0; // lets it shrink as a flex item inside `.id`
  vertical-align: bottom;
}
